<figure class="avatar avatar-{{avatarSize}} rounded-circle shadow">
    <img *ngIf="img" src="{{img}}" [alt]="alt">
    <i *ngIf="!img" [ngClass]="['bi', icon]"></i>
</figure>
<app-role-pin *ngIf="roles" [roles]="roles"></app-role-pin>
